// src/theme/palette.js
const palette = {
  primary: {
    main: '#1AC99F', // Turquoise color from the image
    light: '#4EDCB9',
    dark: '#0E9A78',
    contrastText: '#ffffff',
    aa:'#23b399'
  },
  secondary: {
    main: '#2E8B8B', // Teal shade
    light: '#4AA7A7',
    dark: '#1E6565',
    contrastText: '#ffffff',
  },
  error: {
    main: '#e74c3c',
    light: '#ff7f6e',
    dark: '#af0e0e',
    contrastText: '#ffffff',
  },
  warning: {
    main: '#f39c12',
    light: '#ffce4b',
    dark: '#b96d00',
    contrastText: '#ffffff',
  },
  info: {
    main: '#3498db',
    light: '#6fc8ff',
    dark: '#006ba9',
    contrastText: '#ffffff',
  },
  success: {
    main: '#2ecc71',
    light: '#6effa0',
    dark: '#009a44',
    contrastText: '#ffffff',
  },
  grey: {
    100: '#f8f9fa',
    200: '#e9ecef',
    300: '#dee2e6',
    400: '#ced4da',
    500: '#adb5bd',
    600: '#6c757d',
    700: '#495057',
    800: '#343a40',
    900: '#212529',
  },
  background: {
    default: '#f8f9fa',
    paper: '#ffffff',
    login: 'linear-gradient(135deg, rgba(30, 101, 101, 0.95) 0%, rgba(26, 201, 159, 0.85) 100%)',
  },
  text: {
    primary: '#212529',
    secondary: '#6c757d',
    disabled: '#adb5bd',
    contrast: '#ffffff',
  },
  divider: '#e9ecef',
};

export default palette;